import { Debt } from "../../types/accounts"

type DebtsState = Debt[];

interface DebtsAction {
  type: string,
  debt: Debt,
}

export default (state: DebtsState = [], action: DebtsAction): DebtsState => {
  switch (action.type) {
    case 'DEBTS_NEW':
      return [...state, action.debt];
    default:
      return state;
  }
};